import Head from 'next/head';
import { TFunction } from 'next-i18next';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONDITION_DESKTOP, SUPPORT_EMAIL, SUPPORT_TELEGRAM } from 'shared/common/constants';
import { routes } from 'shared/common/routes';
import styled from 'styled-components';
import { MainLayout } from 'widgets/layouts';

import { rulesList } from './rules-list';
import { RulesSection } from './ui';

const getNavbar = (t: TFunction) => [
  {
    text: t('defaultNavbar.findExperts'),
    href: routes.topics,
  },
  {
    text: t('defaultNavbar.becomeExpert'),
    href: routes.expertLanding,
  },
];

export const Rules: FC = () => {
  const { t } = useTranslation('header.component');

  return (
    <MainLayout hasFooter head={{ title: 'Правила сервиса Consulty' }} navbar={getNavbar(t)} isLoginButtonVisible>
      <Head>
        <meta name="title" content="Правила сервиса Consulty" />
        <meta name="description" content="Правила сервиса Consulty" />
        <meta name="og:title" content="Правила сервиса Consulty" />
        <meta name="og:site_name" content="www.consulty.online" />
        <meta name="og:url" content="https://www.consulty.online/academy/" />
        <meta name="og:description" content="Правила сервиса Consulty" />
      </Head>

      <h1 className="hidden">{t('head.title')}</h1>
      <Content className="container">
        <StyledHeading>Правила сервиса</StyledHeading>
        <RulesSection
          list={rulesList.map((item) => ({
            title: item.title,
            rules: item.rules,
            content: item?.content,
          }))}
        />
        <p>
          Если у вас возникнут какие-то вопросы по поводу данных правил, напишите в поддержку:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> или{' '}
          <a href={`https://t.me/${SUPPORT_TELEGRAM}`}>Telegram</a> или чат справа внизу.
        </p>
      </Content>
    </MainLayout>
  );
};

const Content = styled.main`
  ol {
    line-height: 1.4;
    > li {
      margin-bottom: 10px;
      white-space: break-spaces;
    }
  }
  a {
    color: #8b33ff;
  }
`;

const StyledHeading = styled.h2`
  font-size: 24px;
  color: var(--black2);
  padding: 30px 0 30px;
  ${CONDITION_DESKTOP} {
    padding-top: 60px;
    padding-bottom: 30px;
    text-align: left;
    font-size: 42px;
  }
`;
